var _rect, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgYCallEnded(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#FF4C5E",
    fillOpacity: 0.33
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 16.8618V17.4788C12 18.3308 11.423 19.0828 10.58 19.3288L8.58 19.9158C7.296 20.2918 6 19.3628 6 18.0648V16.1418C6 15.6518 6.125 15.1708 6.44 14.7888C7.174 13.9048 8.88 12.2818 12 11.4778V16.8618ZM20 16.8618V17.2498C20 18.2068 20.723 19.0198 21.7 19.1628L23.7 19.4558C24.91 19.6328 26 18.7268 26 17.5428V15.4198C26 14.8328 25.816 14.2548 25.37 13.8568C24.553 13.1268 22.878 11.9768 20 11.3828V16.8618Z",
    fill: "#FF4C5E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M16 15.396C20 15.396 20 16.862 20 16.862V11.382C18.862 11.147 17.536 11 16 11C14.464 11 13.138 11.184 12 11.478V16.862C12 16.862 12 15.396 16 15.396Z",
    fill: "#FF4C5E"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYCallEnded);
export default __webpack_public_path__ + "static/media/y_call-ended.758b8488cbeddafe316af2084bcae4a5.svg";
export { ForwardRef as ReactComponent };